import { StringOrUndefined } from 'store/entity/types';
import i18n from '../../i18n';

export default {
  title: 'عنوان',
  dueDate: 'مهلت انجام',
  startDate: 'زمان شروع',
  removeDate: 'حذف زمان',
  chooseAnOption: 'مقداری را انتخاب کنید',

  yourProgress(progress: string) {
    return `پیشرفت کار شما: ${progress}%`;
  },
  onlyVerifierCanMark: 'فقط تأییدکننده می‌تواند وضعیت را تغییر دهد',
  chooseVerifyStatus(customTitle?: string) {
    if (customTitle) {
      return `وضعیت ${customTitle} را انتخاب نمایید:`;
    }
    return 'وضعیت تأیید را انتخاب نمایید:';
  },
  status: 'وضعیت: ',
  complete: 'انجام شده',
  incomplete: 'ناتمام',
  started: 'در حال بررسی',
  notStarted: 'انجام نشده',
  rejected: 'رد شده',
  save: 'ذخیره',
  taskWeight: 'وزن',
  progressChangingIsLocked: 'تغییر وضعیت قفل شده است',
  taskPublisher(taskPublisher: StringOrUndefined) {
    if (taskPublisher) {
      return taskPublisher;
    }
    return i18n.t('publishers', { ns: 'taskManager' });
  },
  subTaskPublisher(subTaskPublisher: StringOrUndefined) {
    if (subTaskPublisher) {
      return subTaskPublisher;
    }
    return i18n.t('subtasksPublishers', { ns: 'taskManager' });
  },
  verifyStatus(
    status: string,
    verifierNotStartedTitle: string,
    verifierStartedTitle: string,
    verifierCompleteTitle: string,
    verifierRejectTitle: string
  ) {
    const notStartedTitle = verifierNotStartedTitle
      ? verifierNotStartedTitle
      : 'شروع نشده';
    const startedTitle = verifierStartedTitle
      ? verifierStartedTitle
      : 'در حال بررسی';
    const completeTitle = verifierCompleteTitle
      ? verifierCompleteTitle
      : 'تأیید شده';
    const rejectTitle = verifierRejectTitle ? verifierRejectTitle : 'رد شده';
    switch (status) {
      case 'complete':
        return completeTitle;
      case 'notStarted':
        return notStartedTitle;
      case 'started':
        return startedTitle;
      case 'rejected':
        return rejectTitle;
      default:
        return 'هنوز مشخص نشده';
    }
  },
  mainProgress: (mainProgressTitle: string) =>
    mainProgressTitle ? mainProgressTitle : 'پیشرفت اصلی',
  secondaryProgress: (secondaryProgressTitle: string) =>
    secondaryProgressTitle ? secondaryProgressTitle : 'پیشرفت فرعی',
  addASubtask: (subTasksTitle: string | undefined) => {
    return i18n.t('addASubtask', {
      ns: 'taskManager',
      subTasksTitle: subTasksTitle || i18n.t('task', { ns: 'taskManager' }),
    });
  },
  saveAndAddASubtask: (subTasksTitle: string | undefined) => {
    return i18n.t('saveAndAddASubtask', {
      ns: 'taskManager',
      subTasksTitle: subTasksTitle || i18n.t('task', { ns: 'taskManager' }),
    });
  },
  followers(customTitle: StringOrUndefined) {
    if (customTitle) {
      return customTitle;
    }
    return i18n.t('followers', { ns: 'taskManager' });
  },
  verifier(verifierTitle: StringOrUndefined) {
    if (verifierTitle) {
      return verifierTitle;
    }
    return i18n.t('verifier', { ns: 'taskManager' });
  },
  assignee(customTitle: StringOrUndefined) {
    if (customTitle) {
      return customTitle;
    }
    return i18n.t('assignee', { ns: 'taskManager' });
  },
  taskTemplateName(templateName: string) {
    return i18n.t('taskTemplateName', { ns: 'taskManager', templateName });
  },
};
